module.exports = __webpack_public_path__ + "img/splashScreen4_veryHigh.d694ab41.jpg";